import { Column, Row, Text } from "@/components";
import { ScreenBreakdownRows } from "@/components/dashboard/dashboard-stats/ScreenBreakdownRows";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@ui/dialog";

import { useGetDashboardStafferScreenBreakdown } from "@/hooks/queries/useGetDashboardStafferScreenBreakdown";
import { GoalPeriod } from "@/types";

// The candidacies behind one week's time-to-first-screen median, slowest
// first. A dialog rather than an in-card view — the card is too short to list
// them usefully.
export const DashboardScreenBreakdownDialog = ({
  isOpen,
  medianHours,
  onClose,
  period,
  subtitle,
  userId,
  weekStart,
}: {
  isOpen: boolean;
  medianHours: number | null;
  onClose: () => void;
  period: GoalPeriod;
  subtitle: string;
  userId: number;
  // One Saturday-Friday week, or null for the whole period.
  weekStart: string | null;
}) => {
  /* Database CRUD Operations */
  // Read — loaded lazily, only once the staffer opens the breakdown.
  const { data: screenBreakdown, isPending } =
    useGetDashboardStafferScreenBreakdown({
      userId,
      period,
      weekStart,
      enabled: isOpen,
    });

  /* Handlers */
  const handleOpenChange = (open: boolean) => {
    if (!open) onClose();
  };

  /* Render */
  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogContent className="flex h-96 max-w-lg flex-col gap-4">
        <DialogHeader>
          <Row className="items-baseline gap-2 pr-6">
            <DialogTitle>Time to first screen</DialogTitle>
            <Text className="text-xs font-normal text-slate-500">
              {subtitle}
            </Text>
          </Row>
        </DialogHeader>
        <Column className="min-h-0 flex-1">
          <ScreenBreakdownRows
            isPending={isPending}
            medianHours={medianHours}
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            rows={screenBreakdown || []}
          />
        </Column>
      </DialogContent>
    </Dialog>
  );
};
